import { useState, useCallback } from "react";
import axios from "../axios_config";
import { BASE_API_URL, REFERRAL_MENTOR_BIND } from "../common/endpoints";
import { useUserDataContext } from "../user_data_context";

export const MENTOR_REF_KEY = "mentor_ref_token";

const ERROR_CODE_MAP = {
	4091: "already_has_mentor",
	4092: "mentor_limit_reached",
	4090: "self_referral",
	4000: "invalid_token",
	4040: "invalid_token",
};

export function useReferralMentor() {
	const { fetchUserData } = useUserDataContext();
	const [bindModalState, setBindModalState] = useState(null); // { type, mentorName }

	const bindMentor = useCallback(async () => {
		const token = sessionStorage.getItem(MENTOR_REF_KEY);
		if (!token) return;

		try {
			const response = await axios.post(`${BASE_API_URL}${REFERRAL_MENTOR_BIND}`, { token });
			sessionStorage.removeItem(MENTOR_REF_KEY);
			fetchUserData();
			const mentor = response.data?.user?.user_mentor;
			const mentorName =
				mentor?.user_name && mentor?.user_second_name
					? `${mentor.user_name} ${mentor.user_second_name}`
					: null;
			setBindModalState({ type: "success", mentorName });
		} catch (error) {
			sessionStorage.removeItem(MENTOR_REF_KEY);
			const code = error.response?.data?.code;
			setBindModalState({ type: ERROR_CODE_MAP[code] ?? "bind_error", mentorName: null });
		}
	}, [fetchUserData]);

	const closeBindModal = useCallback(() => {
		setBindModalState(null);
	}, []);

	return { bindMentor, bindModalState, closeBindModal };
}
